import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// SAP Fiori-style "Object Status" tag (Oct 13 2026, user's explicit ask:
// "eliminate this pill design... make sure it is ERP-level professional")
// - crisp micro-radius rectangle, 1px border, colored left accent strip,
// tinted (not solid) background, uppercase small text. Reserved for real
// multi-state STATUS values only - plain reference data (an ID, a number)
// or a simple done/true confirmation should NOT use this component at
// all, per the same conversation (render as plain text instead).
const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-[3px] border border-l-[3px] px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-[#F0FDF4] border-[#BBF7D0] border-l-[#16A34A] text-[#15803D]",
        success:
          "bg-[#F0FDF4] border-[#BBF7D0] border-l-[#16A34A] text-[#15803D]",
        warning:
          "bg-[#FFFBEB] border-[#FDE68A] border-l-[#D97706] text-[#B45309]",
        destructive:
          "bg-[#FEF2F2] border-[#FECACA] border-l-[#DC2626] text-[#B91C1C]",
        secondary:
          "bg-[#F8FAFC] border-[#E2E8F0] border-l-[#64748B] text-[#475569]",
        outline: "bg-transparent border-border border-l-border text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
